import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import analytics from "../util/analytics";
import { useAuth } from "$/util/auth";
import AuthModal from "./AuthModal";
import commonConstants from "$/data/common";

const CONTENT = {
  expired: {
    title: "Your subscription has expired.",
    desc: "Renew your subscription to continue creating tattoos.",
    cta: "Renew subscription",
    link: "/settings/billing",
    action: "resubscribe",
  },
  depleted: {
    title: "Go Pro Unlimited",
    desc: "Create Unlimited Tattoos with access to all premium features.",
    cta: "Create Unique Designs in Seconds",
    link: "/pricing",
    action: "upgrade",
  },
  anonymous: {
    title: "Go Pro Unlimited",
    desc: "Create Unlimited Tattoos with access to all premium features.",
    cta: "Create Unique Designs in Seconds",
    action: "join",
  },
};

function ExpiredOverlay(props: { disableAuthPopup?: boolean; allowFree?: boolean }) {
  const auth = useAuth();

  const [shownOnce, setShownOnce] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);

  const creditsDepleted = auth.user && auth.user.credits <= 0 && !auth.isProUser;
  const hasSubscription = auth.user && auth.user.stripeSubscriptionId;

  const status =
    creditsDepleted && !props.allowFree
      ? "depleted"
      : hasSubscription && !props.allowFree
      ? "expired"
      : auth.isAnonymousUser && auth.user && auth.user.credits <= commonConstants.FREE_USABLE_CREDITS
      ? "anonymous"
      : null;

  const show = useCallback(() => {
    if (shownOnce) {
      return;
    }
    setShowAuthModal(true);
    setShownOnce(true);
  }, [shownOnce, setShowAuthModal, setShownOnce]);

  // useEffect(() => {
  //   if (
  //     auth.isAnonymousUser &&
  //     auth.user &&
  //     auth.user.credits <= 4 &&
  //     !props.disableAuthPopup
  //   ) {
  //     const timer = setTimeout(() => {
  //       show();
  //     }, 3000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [auth.isAnonymousUser, auth.user, show, props.disableAuthPopup]);

  if (!status) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(255, 255, 255, 0.7)",
        backdropFilter: "blur(1px)",
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Stack spacing={2} mx={4}>
        <Typography variant="h4">{CONTENT[status].title}</Typography>
        <Typography variant="h5">{CONTENT[status].desc}</Typography>
        <Button
          component={status !== "anonymous" ? Link : undefined}
          to={status !== "anonymous" ? CONTENT[status].link : undefined}
          onClick={() => {
            analytics.track("cta-click", {
              context: "expired-overlay",
              action: CONTENT[status].action,
              status,
            });
            if (status === "anonymous") {
              setShowAuthModal(true);
              setShownOnce(true);
            }
          }}
          variant="contained"
          color="primary"
          sx={{ mt: 1 }}
        >
          <strong>{CONTENT[status].cta}</strong>
        </Button>
      </Stack>
      <AuthModal
        open={showAuthModal}
        onClose={() => {
          setShowAuthModal(false);
        }}
      />
    </Box>
  );
}

export default ExpiredOverlay;
